import {SiePedidosBaseAPI} from "@/api/sie-pedidos.base.api";
import {
  API_URL_FORGOT,
  ID_APP,
  VUE_APP_SIE_PEDIDOS_API_LOGIN_URL,
  VUE_APP_SIE_PEDIDOS_API_URL
} from "@/commons/config";
import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {DadosAluno} from "@/models/sie-pedidos/dadosAluno";
import {User} from "@/models/user";

export class AuthApi extends SiePedidosBaseAPI<DadosAluno> {
  constructor() {
    super();
    this.apiUrl = VUE_APP_SIE_PEDIDOS_API_URL;
  }
  public signin (usernameOrEmail: string, password: string): AxiosObservable<User> {
    return this.axios.post(`${VUE_APP_SIE_PEDIDOS_API_LOGIN_URL}`, { usernameOrEmail, password, application: ID_APP })
  }
  public recuperarSenha (login: string): AxiosObservable<any> {
    return this.axios.post(`${API_URL_FORGOT}/auth/forgot-password`, {login, application: ID_APP})
  }
  public dadosUserLogado (): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/user-info` )
  }
  public dadosUserGraficaLogado (): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/user-grafica-info` )
  }
}
